import React from 'react';
import emojis from 'theme/emoji';
import { TableMyNotes } from 'components/organisms/Table/TableMyNotes';
import { ContainerFullWidth } from 'components/layouts/ContainerFullWidth';
import { ContainerTwoThirds } from 'components/layouts/ContainerTwoThirds';
import { FeatureMySkills } from 'components/organisms/Features/FeatureMySkills';
import { MobileTabLineBox } from 'components/atoms/Texts/MobileTabLineBox';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { formatDate } from 'helpers/date/formatDate';
import { TableData } from 'components/organisms/Table/TableData';
import { TableDataLineQuiz } from 'components/organisms/Table/TableData/TableDataLineQuiz';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import { useQuery } from '@apollo/client';
import { QUERY_GET_MY_NOTE_IN_CLASSE } from '../../graphql/query/note/getNoteQuery';
import { MY_ID } from '../../helpers/user/authorization';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { useRefetchData } from '../../helpers/refetch/refetchData';
import { GetMyNoteInClasseQuery } from '../../graphql/generated/graphql';
import { getQuizToNoteDefFromQuery } from '../../helpers/transformApiResponse/quizToNote';
import { useMediaQuery } from 'hooks/useMediaQuery';
import { EmptyDataMessage } from '../../components/molecules/EmptyDataMessage';

const MesNotes = () => {
  const { loading, error, data, refetch } = useQuery<GetMyNoteInClasseQuery>(
    QUERY_GET_MY_NOTE_IN_CLASSE,
    {
      variables: { id: MY_ID }
    }
  );
  const isMobile = useMediaQuery('mobile');

  useRefetchData(refetch);
  if (loading) return <LoadingLayout />;
  if (error)
    return <ErrorContainer text={'Erreur dans la récupération des notes'} />;

  const quiztonotes = data.getMyNoteInClasse.quizToNotes.map(qtn =>
    getQuizToNoteDefFromQuery(qtn)
  );
  return (
    <div>
      <ContainerTwoThirds col1={<TableMyNotes />} col2={<FeatureMySkills />} />
      <ContainerFullWidth gap="small">
        <HeaderText
          text="Mes notes de quiz"
          emoji={emojis['Fire']}
          marginTop={true}
        />

        {quiztonotes.length === 0 ? (
          <EmptyDataMessage
            text="Vous n'avez pas encore de notes pour les quiz 😕"
            isVisible={true}
          />
        ) : (
          <>
            {isMobile ? (
              <FeatureContainer>
                {quiztonotes.map(qtn => {
                  if (!qtn.quiz) return null;
                  return (
                    <MobileTabLineBox
                      key={qtn.id}
                      texts={[
                        { text: qtn.quiz.name, style: 'bold' },
                        {
                          text:
                            'Du ' +
                            formatDate(new Date(qtn.quiz.debut)) +
                            ' au ' +
                            formatDate(new Date(qtn.quiz.fin))
                        },
                        {
                          text: qtn.note.toString() + ' / 20',
                          style: 'bottomQuiz'
                        }
                      ]}
                    />
                  );
                })}
              </FeatureContainer>
            ) : (
              <TableData tabLabels={['Nom du quiz', 'Date', 'Note']}>
                {quiztonotes.map((qtn, index) => {
                  if (!qtn.quiz) return null;
                  return <TableDataLineQuiz quiz={qtn} key={index} />;
                })}
              </TableData>
            )}
          </>
        )}
      </ContainerFullWidth>
    </div>
  );
};

export default MesNotes;
